module.exports = __webpack_public_path__ + "static/media/logo-conagra1.a07838a6.png";